<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-12">
        <indexHeader
          :title="$t('Sale returns')"
          :description="$t('From here you can control sales invoices')"
        />
        <indexTable
          :searchText="$t('search for an invoice')"
          :emptyTableText="$t('There are no bills')"
          :emptyTableSubText="$t('Try adding some items to the table and try again')"
          :buttonRole="$checkRole('sale_returns_add')"
          :statusSearch="true"
          :statusValues="[
            { title: $t('Situation'), value: '' },
            { title: $t('All'), value: '' },
            { title: $t('Draft'), value: 0 },
            { title: $t('Sent'), value: 1 },
            { title: $t('Seen'), value: 2 },
            { title: $t('Driven'), value: 3 },
            { title: $t('Canceled'), value: 4 }
          ]"
          :cloumns="[
            {
              column: 'code',
              title: $t('invoice'),
              type: 'mainLink',
              sort: true
            },
            {
              column: 'date',
              title: $t('The date of the invoice'),
              type: 'text',
              sort: true
            },
            {
              column: 'client_type',
              title: $t('Customer name'),
              type: 'clintLink',
              sort: false
            },
            {
              column: 'total',
              title: $t('Cost'),
              type: 'text',
              sort: true
            },
            {
              column: 'rest',
              title: $t('Balance'),
              type: 'text',
              sort: true
            },
            {
              column: 'user_name',
              title: $t('Responsible name'),
              type: 'text',
              sort: true
            },
            {
              column: 'status',
              title: $t('Situation'),
              type: 'status',
              sort: true,
              values: [
                { title: $t('Draft'), value: 0, color: 'dark' },
                { title: $t('Sent'), value: 1, color: 'primary' },
                { title: $t('Seen'), value: 2, color: 'primary' },
                { title: $t('Driven'), value: 3, color: 'success' },
                {
                  title: $t('Canceled'),
                  value: 4,
                  color: 'danger'
                }
              ]
            },
            {
              column: 'options',
              title: $t('Settings'),
              type: 'options',
              options: [
                { name: 'show' },
                {
                  name: 'edit',
                  role: $checkRole('sale_returns_edit') && !$option.e_invoicing
                },
                { name: 'file' },
                { name: 'outLink', role: true },
                { name: 'printSaleReturn', role: true },
                { name: 'download', role: true },
                {
                  name: 'delete',
                  role: $checkRole('sale_returns_delete') && !$option.e_invoicing
                }
              ]
            }
          ]"
          :deleteText="{
            attention: $t('Attention'),
            areYouReallySureToDeleteTheItem: $t('Are you really sure to delete the item'),
            close: $t('Close'),
            confirm: $t('Confirm'),
            loading: $t('Loading')
          }"
        />
      </div>
    </div>
  </div>
</template>
<script>
import indexHeader from '@/elements/index/indexHeader.vue'
import indexTable from '@/elements/index/indexTable.vue'

export default {
  data() {
    return {
      path: '/saleReturns'
    }
  },
  components: {
    indexHeader,
    indexTable
  }
}
</script>
